<!DOCTYPE html>
<html lang="en">

<head>
    <title>CARDATA Account Deletion Request</title>
    <meta charset="utf-8" />
    <meta name="viewport" content="width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=no" />
    <base href="/">
    <script src="assets/js/jquery-3.3.1.js"></script>
</head>

<body>
    <div class="page">
        <div class="container-fluid login">
            <div class="row">
                <div class="col-md-12">
                    <div class="box mt40 mb40 static">
                        <div class="row">
                            <div class="col-lg-12">
                                <div class="static-content">
                                    <p><b>Cardata Account Deletion Request</b></p>
                                    <p>
                                        If you would like to delete your membership and account on the Cardata mobile application, please follow these steps:
                                    </p>
                                    <ol>
                                        <li>Log in to the Cardata application.</li>
                                        <li>Navigate to the Profile (My Account) tab.</li>
                                        <li>Tap the "Delete Account" button and confirm your action.</li>
                                    </ol>
                                    <p>
                                        Alternatively, you can request the deletion of your account by sending an email with the subject "Account Deletion Request" from your registered email address to <b>info@cardata.com.tr</b>. Once your request is received, your data will be processed and the deletion will be completed within 7 (seven) business days.
                                    </p>
                                    <p><b>Information on Deleted and Retained Data:</b></p>
                                    <ul>
                                        <li><b>Deleted Data:</b> Upon your request, your name, surname, contact number, personal profile information obtained within the scope of your membership, and your favorite vehicle listings or searches on the Cardata application will be permanently deleted.</li>
                                        <li><b>Retained Data & Retention Period:</b> IP log records and basic contract/transaction metadata approved during your membership, which are mandatory to be retained in accordance with legal regulations (e.g., access records or tax/commercial obligations), are kept in an encrypted and secure environment for legal requirements throughout the statutory retention period (standard of 10 years).</li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</body>
</html>
